import Big from 'big.js';
import IPurchaseExchangeRates from '@appInterfaces/IPurchaseExchangeRates';
import { CRYPTO_PLACES, decimalPlaces } from '@appComponents/CurrencyElement/CurrencyElement';
import { IGetPurchaseFees } from './IPurchaseForm';

const getPurchaseFees = (amount: number, exchangeRates: IPurchaseExchangeRates,
                         currencyToPay: string, globalPurchaseFee: string): IGetPurchaseFees => {
  let purchaseFee: number | string = 0;
  let totalToPay = 0;
  let priceFor1Token = 0;

  if (exchangeRates) {
    const totalPayWithoutFee = getTotalPayWithoutFee(amount, exchangeRates, currencyToPay);
    purchaseFee = getPurchaseFee(false, totalPayWithoutFee, globalPurchaseFee);
    totalToPay = Number(getTotalToPay(amount, currencyToPay, exchangeRates, globalPurchaseFee, totalPayWithoutFee));
    priceFor1Token = getPriceFor1Token(exchangeRates, currencyToPay);
  }

  return {
    purchaseFee,
    totalToPay,
    priceFor1Token,
  };
};

const getTotalPayWithoutFee = (amount: number, exchangeRates: IPurchaseExchangeRates, currencyToPay: string) => {
  const exchangeRate = exchangeRates['bft_' + currencyToPay.toLowerCase()];
  return Big(amount).div(exchangeRate);
};

const getPurchaseFee = (skipFree: boolean = false, totalPayWithoutFee: Big, globalPurchaseFee: string) => {
  if (Big(globalPurchaseFee).eq(0) && !skipFree) return 'Free';
  return Number(totalPayWithoutFee.div(100).times(globalPurchaseFee));
};

const getPriceFor1Token = (exchangeRates: IPurchaseExchangeRates, currencyToPay: string) => {
  return exchangeRates ? Number(getTotalPayWithoutFee(1, exchangeRates, currencyToPay)) : 0;
};

export const getTotalToPay = (
  amount: number,
  currencyToPay: string,
  exchangeRates: IPurchaseExchangeRates,
  globalPurchaseFee: string,
  totalPayWithoutFee?: Big
) => {
  const _totalPayWithoutFee = totalPayWithoutFee || getTotalPayWithoutFee(amount, exchangeRates, currencyToPay);
  const rounded = _totalPayWithoutFee.round(decimalPlaces[currencyToPay.toLowerCase()] || CRYPTO_PLACES, 0);

  return Big(rounded).plus(getPurchaseFee(true, _totalPayWithoutFee, globalPurchaseFee));
};

export default getPurchaseFees;
